export class OrdenCompra {
    numint: number = null;
    fecha: string = '';
    numero: string = null;
    contacto: string = '';
 }
 
 export class DocumentoCabAlmacen {
    numint: number = null;
    codenv: number = null;
    direc1: string = '';
    direc2: string = '';

 }

 export class DocumentoCabAlmacenGuiaRemPuntoVenta {
   numint: number = null;
   codenv: number = null;
   direc1: string = '';
   direc2: string = '';
   ubigeo: string = '';
}

 export class DocumentoCabOrdcom {
   numint: number = null;
   fecha: string = '';
   numero: string = null;
   contacto: string = '';
}

export class DocumentoCabCPago {
   numint: number = null;
   item: number = null;
   dias: number = null;
}

export class DocumentoRelacion {
   numint: number = null;
   tipdoc: number = null;
   series: string = '';
   numdoc: number = null;
   femisi: string = '';
   numintre: number = null;
}

export class ClaseCodigoDescripcion {
   clase: number = null;
   desclase: string = '';
   codigo: string = '';
   descodigo: string = '';
}

export class ClienteAlmacen {
   codcli: string = '';
   codenv: number = null;
   descri: string = '';
   direc1: string = '';
   direc2: string = '';
   telenv: string = '';
   faxenv: string = '';
   coddep: string = '';
   codprv: string = '';
   coddis: string = '';
   codzon: number = null;
   usuari: string = '';
   swacti: string = '';
   codcen: string = '';
   departamento: string = '';
   provincia: string = '';
   distrito: string = '';
   ubigeo: string = '';
   clases: ClaseCodigoDescripcion[];
}

export class ClienteContacto {
   codcont: number = null;
   codcli: string = '';
   nomcont: string = '';
   telefono: string = '';
   correo: string = '';
}

export class ClienteEspecificacion {
   codesp: number = null;
   descri: string = '';
   vreal: number = null;
   vstrg: string = '';
   vchar: string = '';
   vdate: string = '';
   vtime: string = '';
   ventero: number = null;
}

export class ClienteBanco {
   codban: number = null;
   desban: string = '';
   tipcta: number = null;
   descta: string = '';
   tipmon: string = '';
   cuenta: string = '';
}

export class ClienteCodPag {
   codcli: string = '';
   codpag: number = null;
   despag: string = '';
   fcreac: string = '';
   factua: string = '';
   usuari: string = '';
   swdefaul:boolean = false;
   swacti:boolean = false;
}

export class DocumentoCabClase {
   numint:      number = null;
   clase:       number = null;
   codigo:      string = '';
   descodigo:   string = '';
   vreal:       number = null;
   vstrg:       string = '';
   vchar:       string = '';
   vdate:       string = '';
   vtime:       string = '';
   ventero:     number = null;
   vglosa:      string = '';
   codusercrea: string = '';
   coduseractu: string = '';
   fcreac:      string = '';
   factua:      string = '';    
}